module.exports = ".marcoSubtitulo {\n    padding: 0px !important;\n}\n\n.marcoSubtitulo p {\n    margin-bottom: 20px;\n}\n\n.marcoSubtitulo h3 {\n    margin-bottom: 10px;\n}\n\n.rowdiv {\n    display: flex; /* equal height of the children */\n    clear: both;\n    flex-wrap: wrap;\n}\n\n@media (max-width: 766px) {\n    .rowdiv {\n        display: block; /* equal height of the children */\n    }\n}\n\n.coldiv {\n    flex: 1;\n}\n\n.datos {\n    height: 100%;\n}"


//////////////////
// WEBPACK FOOTER
// ./app/miCuenta/miCuenta.component.css
// module id = 1010
// module chunks = 0